import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireSceneEvents = (engine: TriggerEngine): EventSourceResult => {
  const onSceneChanged = () => engine.fireEvent("scene_switched");

  engine.Radio.ScenesManager.watch("model", onSceneChanged);

  return {
    unsubscribers: [
      () => engine.Radio.ScenesManager.unwatch("model", onSceneChanged),
    ],
  };
};
